var draggableDrawerTexts = {
  'sv-SE': {
    close: 'Stäng'
  },
  'nb-NO': {
    close: 'Lukk'
  },
  'da-DK': {
    close: 'Tæt'
  },
  'fi-FI': {
    close: 'Kiinni'
  },
  en: {
    close: 'Close'
  }
};
var texts = draggableDrawerTexts;

export { texts as default };
//# sourceMappingURL=DraggableDrawer.texts.js.map
